import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, filter, mergeMap } from 'rxjs/operators';
import {
  STATE_EDIT_MODE,
  STATE_FIND,
  STATE_FIND_ALL,
  STATE_FIND_ALL_SUCCESS,
  STATE_FIND_SUCCESS,
  STATE_UPDATE_LOADING,
  SERVICE_FAILURE,
} from '@store/actions';
import { Estado } from '@core/models';
import { StateService } from '@core/services';

@Injectable()
export class StateEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private stateService: StateService
  ) { }

  findState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(STATE_FIND),
      filter((action) => action.id !== null),
      mergeMap(({ id }) => {
        this.store.dispatch(STATE_UPDATE_LOADING({ loading: true }));

        return this.stateService.getState(id).pipe(
          mergeMap(({ data }) => {
            const [stateData] = data as Estado[];

            return [
              STATE_EDIT_MODE({ editMode: true }),
              STATE_UPDATE_LOADING({ loading: false }),
              STATE_FIND_SUCCESS({ stateData }),
            ];
          }),
          catchError((error) => 
            of(error).pipe(
              mergeMap((error) => {
                return [
                  SERVICE_FAILURE({ error }),
                  STATE_UPDATE_LOADING({ loading: false }),
                ];
              })
            )
          )
        )
      }),
    )
  );

  findCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(STATE_FIND_ALL),
      mergeMap(() => {
        this.store.dispatch(STATE_UPDATE_LOADING({ loading: true }));

        return this.stateService.getStates().pipe(
          mergeMap(({ data }) => {
            const stateList = data as Estado[];
            return [
              STATE_FIND_ALL_SUCCESS({ stateList }),
              STATE_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) => 
            of(error).pipe(
              mergeMap((error) => {
                return [
                  SERVICE_FAILURE({ error }),
                  STATE_UPDATE_LOADING({ loading: false }),
                ];
              })
            )
          )
        )
      }),
    )
  );
}
